const swalSuccess = function (message) {
    return Swal.fire({
            title: "Success",
            text: message,
            type: "success",
            icon: "success",
            allowOutsideClick: false,
        });
};

const swalError = function (message) {
    return Swal.fire({
        title: "Error",
        text: message,
        type: "error",
        icon: "error",
    });
};

const swalWarning = function (message) {
    return Swal.fire({
        title: "Warning",
        text: message,
        type: "warning",
        icon: "warning",
    });
};

export default { swalSuccess, swalWarning, swalError };
